// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1xQIp","item":"PaymentsMobile_item__3HF25","label":"PaymentsMobile_label__2Htuw","amount":"PaymentsMobile_amount__2vK86"};